import { getCorrectionsForSigSync } from '../../../../../../types/signingAppointment/ISigningAppointmentResponse';
import React, { useState } from 'react';
import { checkForMutationSuccess } from '../../../../../../API/checkForMutationSuccess';
import { Corrections } from './Corrections';
import { HeaderText2TW } from '../../../../../../tailwindComponents/HeaderTextTW/HeaderTextTW';
import { BodyTextTW } from '../../../../../../tailwindComponents/bodyText/BodyTextTW';
import { ButtonTW } from '../../../../../../tailwindComponents/buttonTW/ButtonTW';
import { Show } from '../../../../../shared/Show';
import { SpinnerTW } from '../../../../../../tailwindComponents/spinnerTW/SpinnerTW';
import { SpinnerSize } from '../../../../../../ui-toolkit';
import { SigningAppointmentApi } from 'API/order/signingAppointment/SigningAppointmentAPI';
import { useSelectAppointmentFromPathParam } from '../../../../../../utilities/order/scheduling/useSomeAppointmentFromParam';
import { useParams } from 'react-router-dom';
import { UUID } from '../../../../../../types/shared/UUID';

interface ConfirmationProps {
  onClose: () => void;
}

export const Confirmation = ({ onClose }: ConfirmationProps) => {
  const { orderId } = useParams<{ orderId: UUID; appointmentId?: UUID }>();
  const { appointmentFromPath } = useSelectAppointmentFromPathParam();

  const [corrections, setCorrections] = useState<string[]>([]);
  const [updateMutation, { isLoading: sigSyncMutationIsLoading }] = SigningAppointmentApi.useUpdateMutation();

  if (!appointmentFromPath) {
    return null;
  }

  const onConfirmClick = async () => {
    const correctionsResult = getCorrectionsForSigSync(appointmentFromPath);
    setCorrections(correctionsResult);
    if (correctionsResult.length === 0) {
      const res = await updateMutation({
        orderId,
        id: appointmentFromPath.id,
        data: { isSignatureSyncAppointment: true },
      });
      checkForMutationSuccess(res, 'Signing Appointment integration');
      onClose();
    }
  };

  if (corrections.length > 0) {
    return <Corrections corrections={corrections} onClose={onClose} />;
  }

  return (
    <div className={'flex flex-col gap-3 p-2'}>
      <section>
        <HeaderText2TW>Signature Sync Integration</HeaderText2TW>
      </section>
      <section className={'flex justify-center justify-items-center'}>
        <BodyTextTW>
          This action will integrate this signing appointment with Signature Sync, are you sure you want to continue?
        </BodyTextTW>
      </section>
      <section className={'flex flex-row justify-between'}>
        <ButtonTW secondary onClick={onClose}>
          No
        </ButtonTW>
        <Show when={!sigSyncMutationIsLoading} fallback={<SpinnerTW size={SpinnerSize.small} />}>
          <ButtonTW onClick={onConfirmClick}>Yes</ButtonTW>
        </Show>
      </section>
    </div>
  );
};
